"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "loreo": {
    "d63746e9": [{
      "hkey": "24247994",
      "slug": "loreo",
      "name": "Loreo",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonino": [{
      "hkey": "24247994",
      "slug": "loreo",
      "name": "Loreo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;